import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { Period } from '../../../components/modals/LogsModal/utils'
import { hideModal } from '../../actions/modalActions'
import fileDownload from 'js-file-download'
import { getUrl } from '../../../api/api'

export const downloadServerLogs = createAsyncThunk<
    void,
    { datesToSend: Period },
    ThunkConfig<string>
>('logsSlice/downloadServerLogs', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { datesToSend } = args
    try {
        const res = await api.post(
            getUrl('/info/logs'),
            datesToSend,
            {
                responseType: 'blob',
            }
        )

        if (res.status === 204) {
            throwSuccessMessage('No files found')
            dispatch(hideModal())
            return
        }

        if (res.status === 200) {
            const fileName =
                res.headers['content-disposition']
                    ?.split('=')[1]
                    ?.split(';')[0] ||
                `${datesToSend.period.from}-${datesToSend.period.to}.zip`

            fileDownload(res.data, fileName)
            dispatch(hideModal())
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to download server logs')
    }
})
